export const GoogleMapApiConfig = 'AIzaSyBIHxevenBP5f1K-_w_RNqZYiNRc_hZUio';